import { useDispatch } from 'react-redux';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import { LoadingModal, MessageModal } from './component/modal/modal';

function UrlNotice() {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState({ msg: "" });

    const navigate = useNavigate();

    // 초기 진입 세팅
    useEffect(() => {
        dispatch(change_Current_Location("URL경로실패"));
        dispatch(changeHeaderTitle({ mainTitle: "URL경로실패", subTitle: "" }));
        const t = setTimeout(() => setLoading(false), 300);
        return () => clearTimeout(t);
    }, [dispatch]);

    return (
        <>
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            <div className="urlNotice-wrap">
                <div className="urlNotice-center">
                    {/* 경고 아이콘 (SVG) */}
                    <div className="urlNotice-icon" aria-hidden="true">
                        <svg viewBox="0 0 128 128" className="urlNotice-iconSvg" role="img">
                            <g>
                                {/* 받침대 */}
                                <ellipse cx="64" cy="98" rx="40" ry="12" fill="#DBE0E6" />
                                <path d="M64 86c22 0 40 5 40 12s-18 12-40 12" fill="#0F172A" opacity=".9" />
                                {/* 경광등 몸체 */}
                                <rect x="40" y="26" width="48" height="64" rx="24" fill="#FF4B4B" />
                                <rect x="48" y="34" width="32" height="48" rx="16" fill="#FF7676" />
                                <circle cx="64" cy="58" r="12" fill="#FFB1B1" opacity=".7" />
                                {/* 상단 하이라이트 */}
                                <path d="M52 30c4-6 20-6 24 0" fill="#FF8C8C" opacity=".9" />
                            </g>
                        </svg>
                    </div>

                    {/* 제목 */}
                    <h1 className="urlNotice-title">페이지 이동이 차단되었습니다.</h1>

                    {/* 설명문 */}
                    <p className="urlNotice-desc">
                        잘못 된 주소이거나 접근하신 주소가<br />
                        피싱 사이트로 판단되어 이동이 차단되었습니다.
                    </p>
                </div>

                {/* 하단 고정 버튼 영역 */}
                <div className="urlNotice-bottom">
                    <button
                        type="button"
                        className="urlNotice-btn"
                        onClick={() => navigate(-1)}
                    >
                        돌아가기
                    </button>
                </div>
            </div>
        </>
    );
}

export default UrlNotice;
